"use client";

import { useEffect } from "react";
import { useSession } from "@clerk/nextjs";
import { usePathname, useSearchParams } from "next/navigation";

/**
 * Component that conditionally loads the PurposeAI widget
 * Only loads for non-logged users on app.easygpt.builders and excludes certain routes
 */
export function PurposeAIWidgetLoader() {
  const { isSignedIn } = useSession();
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    // TEMPORARILY DISABLED: PurposeAI widget is disabled to prevent it from loading
    // on agent CV pages and external client websites
    
    // Always remove any existing PurposeAI widget script and elements
    const existingScript = document.querySelector(
      'script[src*="w.js/?id=cmithlpao00017c65wdemqwqe"]'
    );
    if (existingScript) {
      existingScript.remove();
    }
    
    // Remove all PurposeAI widget elements that w.js creates
    const widgetElementIds = [
      'easygpt-launcher',
      'easygpt-iframe-container',
      'easygpt-widget-container',
      'easygpt-welcome-bubble'
    ];
    
    widgetElementIds.forEach(id => {
      const element = document.getElementById(id);
      if (element) {
        element.remove();
      }
    });
    
    // Don't load the PurposeAI widget - it's disabled
    return;
  }, [isSignedIn, pathname, searchParams]);

  return null;
}
